module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('VoteBase', {
    scopedSlots: _vm._u([{
      key: "voteMain",
      fn: function() {
        return [_c('div', [_c('b-card', [_c('div', {
          attrs: {
            "slot": "header"
          },
          slot: "header"
        }, [_c('b-button', {
          attrs: {
            "to": {
              name: 'vote-list',
              params: {
                oversea: !!JSON.parse(_vm.$route.query.oversea)
              }
            },
            "size": "sm",
            "variant": "link"
          }
        }, [_c('i', {
          staticClass: "fa fa-chevron-left"
        })]), _vm._v("\n          用户累计投票奖励" + _vm._s(_vm.appName ? '【' + _vm.appName + '】' : '') + _vm._s(!!JSON.parse(_vm.$route.query.oversea) ? _vm.overseaTag : '') + "\n        ")], 1), _vm._v(" "), _c('b-button', {
          style: ({
            marginBottom: '18px'
          }),
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              return _vm.addOneReward()
            }
          }
        }, [_vm._v("添加奖励项")]), _vm._v(" "), _c('b-button', {
          style: ({
            marginBottom: '18px'
          }),
          attrs: {
            "size": "sm",
            "variant": "link"
          },
          on: {
            "click": function($event) {
              return _vm.refresh()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })]), _vm._v(" "), _c('b-table', {
          staticClass: "text-center",
          attrs: {
            "show-empty": "",
            "responsive": "sm",
            "busy": _vm.items === null,
            "items": _vm.items,
            "fields": _vm.fields,
            "current-page": _vm.currentPage,
            "emptyText": _vm.tableEmptyText
          },
          scopedSlots: _vm._u([{
            key: "cell(vote_number)",
            fn: function(data) {
              return [(data.item.disabled) ? [_vm._v("\n              " + _vm._s(data.item.vote_number) + "\n            ")] : [_c('b-form-input', {
                attrs: {
                  "type": "number",
                  "disabled": data.item.disabled,
                  "min": "1",
                  "required": ""
                },
                model: {
                  value: (data.item.vote_number),
                  callback: function($$v) {
                    _vm.$set(data.item, "vote_number", $$v)
                  },
                  expression: "data.item.vote_number"
                }
              })]]
            }
          }, {
            key: "cell(reward_type)",
            fn: function(data) {
              return [_c('b-form-checkbox', {
                attrs: {
                  "switch": "",
                  "required": "",
                  "disabled": data.item.disabled
                },
                on: {
                  "change": function($event) {
                    return _vm.changeRewardType(data.index)
                  }
                },
                model: {
                  value: (data.item.reward_type),
                  callback: function($$v) {
                    _vm.$set(data.item, "reward_type", $$v)
                  },
                  expression: "data.item.reward_type"
                }
              })]
            }
          }, {
            key: "cell(prize)",
            fn: function(data) {
              return [(data.item.disabled) ? [_vm._l((data.item.prize), function(item, idx) {
                return [_c('b-button', {
                  key: idx,
                  staticClass: "prize",
                  attrs: {
                    "variant": "light",
                    "disabled": ""
                  }
                }, [_vm._v("\n                  " + _vm._s(item.name) + " "), _c('b-badge', {
                  attrs: {
                    "variant": "danger",
                    "pill": ""
                  }
                }, [_vm._v(_vm._s(item.number))])], 1)]
              })] : _vm._l((data.item.prize), function(item, idx) {
                return [_c('b-form', {
                  key: idx,
                  staticClass: "prize-form",
                  attrs: {
                    "inline": ""
                  }
                }, [_c('b-form-input', {
                  staticClass: "mb-2 mr-sm-2 mb-sm-0 prize-name",
                  attrs: {
                    "placeholder": "奖励名称"
                  },
                  model: {
                    value: (item.name),
                    callback: function($$v) {
                      _vm.$set(item, "name", $$v)
                    },
                    expression: "item.name"
                  }
                }), _vm._v(" "), _c('b-form-input', {
                  staticClass: "mb-2 mr-sm-2 mb-sm-0",
                  attrs: {
                    "type": "text",
                    "min": "1",
                    "placeholder": "数量",
                    "disabled": !data.item.reward_type
                  },
                  model: {
                    value: (item.number),
                    callback: function($$v) {
                      _vm.$set(item, "number", $$v)
                    },
                    expression: "item.number"
                  }
                }), _vm._v(" "), (idx === 0) ? _c('b-button', {
                  attrs: {
                    "size": "sm",
                    "variant": "outline-primary"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.addPrizeRow(data.index)
                    }
                  }
                }, [_vm._v("Add")]) : _c('b-button', {
                  attrs: {
                    "size": "sm",
                    "variant": "outline-danger"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.deletePrizeRow(data.index, idx)
                    }
                  }
                }, [_vm._v("Delete")])], 1)]
              })]
            }
          }, {
            key: "cell(receive_num)",
            fn: function(data) {
              return [(data.item.disabled) ? [_vm._v("\n              " + _vm._s(data.item.receive_num) + "\n            ")] : [_c('b-form-input', {
                attrs: {
                  "type": "number",
                  "disabled": data.item.disabled,
                  "min": "1",
                  "required": ""
                },
                model: {
                  value: (data.item.receive_num),
                  callback: function($$v) {
                    _vm.$set(data.item, "receive_num", $$v)
                  },
                  expression: "data.item.receive_num"
                }
              })]]
            }
          }, {
            key: "cell(op)",
            fn: function(data) {
              return [(data.item.disabled) ? [_c('b-button', {
                style: ({
                  marginBottom: '18px'
                }),
                attrs: {
                  "size": "sm",
                  "variant": "outline-warning"
                },
                on: {
                  "click": function($event) {
                    return _vm.edit(data.index)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-edit"
              }), _vm._v(" 编辑\n              ")]), _vm._v(" "), _c('b-button', {
                style: ({
                  marginBottom: '18px'
                }),
                attrs: {
                  "size": "sm",
                  "variant": "outline-danger"
                },
                on: {
                  "click": function($event) {
                    return _vm.deleteTip(data.index)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash-o"
              }), _vm._v(" 删除\n              ")])] : [_c('b-button', {
                style: ({
                  marginBottom: '18px'
                }),
                attrs: {
                  "size": "sm",
                  "variant": "outline-success"
                },
                on: {
                  "click": function($event) {
                    return _vm.save(data.index, data.item.new)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-save"
              }), _vm._v(" 保存\n              ")]), _vm._v(" "), _c('b-button', {
                style: ({
                  marginBottom: '18px'
                }),
                attrs: {
                  "size": "sm",
                  "variant": "outline-warning"
                },
                on: {
                  "click": function($event) {
                    return _vm.cancel(data.index, data.item.new)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-save"
              }), _vm._v(" 取消\n              ")])]]
            }
          }, {
            key: "table-busy",
            fn: function() {
              return [_c('div', {
                staticClass: "text-center text-danger my-2"
              }, [_c('b-spinner', {
                staticClass: "align-middle"
              }), _vm._v(" "), _c('strong', [_vm._v("加载中...")])], 1)]
            },
            proxy: true
          }])
        }), _vm._v(" "), _c('nav', [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.totalRows,
            "per-page": _vm.perPage,
            "prev-text": "<<",
            "next-text": ">>",
            "hide-goto-end-buttons": "",
            "first-number": "",
            "last-number": ""
          },
          on: {
            "change": _vm.changePage
          },
          model: {
            value: (_vm.currentPage),
            callback: function($$v) {
              _vm.currentPage = $$v
            },
            expression: "currentPage"
          }
        })], 1)], 1), _vm._v(" "), _c('TipModal', {
          ref: "tip",
          attrs: {
            "tipData": _vm.tipData
          },
          scopedSlots: _vm._u([{
            key: "footer",
            fn: function() {
              return [_c('b-button', {
                attrs: {
                  "size": "sm",
                  "variant": "outline-dark"
                },
                on: {
                  "click": function($event) {
                    return _vm.cancelDelete()
                  }
                }
              }, [_vm._v("取消")]), _vm._v(" "), _c('b-button', {
                attrs: {
                  "size": "sm",
                  "variant": "outline-danger"
                },
                on: {
                  "click": function($event) {
                    return _vm.del()
                  }
                }
              }, [_vm._v("删除")])]
            },
            proxy: true
          }])
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-16f7ac7e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/vote/VoteReward.vue
// module id = TIYK
// module chunks = 4